<div class="admin-notifications-toolbar" *ngIf="showBrowserNotifications">
  <button
    mat-button
    fxHide
    fxShow.gt-xs
    class="admin-notifications-toolbar__button"
    [matMenuTriggerFor]="notifyMenu"
    [matTooltip]="'TOOLBAR.NOTIFICATIONS.TITLE' | translate"
    matTooltipPosition="below">
    <div class="mat-icon-custom">
      <mat-icon>notifications</mat-icon>
      <span
        class="badge"
        [ngStyle]="{
          background: enableNotify.value ? 'rgb(9, 180, 95)' : '#f44336'
        }"></span>
    </div>
  </button>

  <mat-menu
    #notifyMenu="matMenu"
    [overlapTrigger]="false"
    class="admin-notifications-toolbar__menu">
    <div
      fxLayout="row"
      fxLayoutAlign="center center"
      style="min-height: auto"
      mat-menu-item
      (click)="$event.stopPropagation()">
      <mat-slide-toggle
        name="enableNotify"
        [formControl]="enableNotify"
        (change)="toggleNotifications($event.checked)">
        <span>
          {{
            (enableNotify.value
              ? 'TOOLBAR.NOTIFICATIONS.DISABLE'
              : 'TOOLBAR.NOTIFICATIONS.ENABLE'
            ) | translate
          }}
        </span>
      </mat-slide-toggle>
    </div>
  </mat-menu>
</div>
